export const LOAD_METADATA = 'editorAC/MetadataProvider/LOAD_METADATA';
export const LOAD_METADATA_SUCCESS =
  'editorAC/MetadataProvider/LOAD_METADATA_SUCCESS';
export const SET_CATEGORY_GROUPS =
  'editorAC/MetadataProvider/SET_CATEGORY_GROUPS';
export const LOAD_METADATA_ERROR =
  'editorAC/MetadataProvider/LOAD_METADATA_ERROR';
export const SET_LANGUAGE = 'editorAC/MetadataProvider/SET_LANGUAGE';

export const groupCatsID = {
  BUSINESS: [19, 20, 22, 28, 29, 47, 32, 43, 60],
  SNS: [33, 34, 35, 36, 37, 42, 51, 52, 57],
  PRINT: [23, 38, 49, 50, 53, 56],
  POST_CARD: [21, 24, 25, 26, 28, 29, 30, 31],
};
